<template>
    <form>
        <div v-if="useMail">
            <h3 class="form-heading">{{ trans("email_invoice") }}</h3>
            <input type="hidden" name="invoice_id" v-model="model.public_id">
            <input type="hidden" name="company_id" v-model="model.company_id">
            <div class="form-group">
                <label class="control-label" for="from">From</label>
                <select class="form-control" id="from" v-model="model.from">
                    <option v-for="from in model.froms" :value="from.val">{{ from.text }}</option>
                </select>
            </div>

            <div class="form-group">
                <label class="control-label" for="to">To</label>
                <input class="form-control" id="to_name" type="text" name="to" v-model="model.to_name" >
                <input class="form-control" id="to" type="text" name="to" v-model="model.to" >
            </div>

            <div class="form-group invoice-template">
                <label class="control-label" for="viewChange">Change Template</label>
                <small>(This will reset any changes made below)</small>
                <email-template></email-template>
            </div>
        </div>

        <div id="loadTemplate">
            <fieldset>
                <txt id="subject" label="subject" name="options" v-model="model.subject"></txt>

                <div class="split-fields">
                    <txt id="cc" label="CC" name="options" v-model="model.cc"></txt>
                    <txt id="bcc" label="BCC" name="options" v-model="model.bcc"></txt>
                </div>

                <div id="existAttachments" class="form-group" v-if="model.attachments">
                    <label class="control-label">Existing Attachments</label>
                    <ul>
                        <li v-for="(attachment, key) in model.attachments">
                            {{ attachment.filename }}
                            <button class="btn btn-delete" @click.prevent="delRow(key)"><i class="icon icon-cancel"></i></button>
                        </li>
                    </ul>
                </div>

                <div class="form-group">
                    <label class="control-label upload" for="upload">Attachments</label>
                    <input type="file" @change="upload" >
                </div>
                <div v-show="percentCompleted > 0" class="progress">
                    <div class="progress-bar" role="progressbar" :aria-valuenow="percentCompleted" aria-valuemin="0" aria-valuemax="100" :style="'width: ' + percentCompleted + '%;'">
                        <span class="sr-only">{{ percentCompleted }}% Complete</span>
                    </div>
                </div>

                <ckeditor :preventLeave="true" id="mailerHtml" :height="'300px'" :toolbar="[['Source', 'Format'], ['Font','FontSize'],['Bold', 'Italic', 'SpecialChar', 'Scayt'], ['Undo', 'Redo'], ['NumberedList','BulletedList'], ['Link','Unlink'], ['Maximize'], ['Image'], ['Outdent', 'Indent', 'Styles'] ]"></ckeditor>

                <!-- Instructions -->
                <div class="legend">
                    <h4><i class="icon icon-info"></i> Useful Tags</h4>
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <strong>#contactfname</strong> Primary Contact First Name<br />
                            <strong>#contactlname</strong> Primary Contact Last Name<br />
                            <strong>#contactemail</strong> Contact email address<br />
                            <strong>#company</strong> Company name<br />
                            <strong>#signup</strong> URL of Company sign up page<br />
                            <strong>#signature</strong> User Signature<br />
                            <strong>#publicproposal</strong> Public link to download Proposal<br />
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <strong>#business</strong> name of your Business<br />
                            <strong>#myfname</strong> Currently logged in user's first name<br />
                            <strong>#mylname</strong> Currently logged in user's last name<br />
                            <strong>#myemail</strong> Current logged in user's email<br />
                            <strong>#tc</strong> Terms & Conditions URL<br />
                            <strong>#pay</strong> Direct link to pay url<br />
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <div class="form-group send-proposal">
            <input :id="id + 'sendProposal'" type="checkbox" v-model="model.proposal" /> <label :for="id + 'sendProposal'">Send Proposal</label>
        </div>

        <div v-if="useMail" class="section buttons">
            <button @click.prevent="store" class="panelSubmit btn btn-success btn-sm pull-right" :disabled="sent">
                <i class="icon icon-mail"></i>
                <span v-if="!sent">Send</span>
                <span v-if="sent">Sent</span>
            </button>
        </div>
    </form>
</template>
<script>
    import Ckeditor from 'vue-ckeditor2'
    export default {
        props: {
            name: { default: '' },
            id: { default: '' },
            useMail: { default: true },
            invoice_id: {default: 0},
        },
        data() {
            return {
                sent: false,
                percentCompleted: 0,
                model: {
                    public_id: '',
                    company_id: '',
                    from: '',
                    froms: [],
                    to_name: '',
                    proposal: false,
                    to: '',
                    subject: '',
                    cc: '',
                    bcc: '',
                    html: '',
                    attachments: [],
                }
            }
        },
        components: {
            'ckeditor': require('../ckeditor/ckeditor.vue').default,
            'email-template': require('../../components/email/templates.vue').default
        },
        watch: {
            model: {
                handler: function (val, oldVal) {
                    this.$emit('input', this.model);
                },
                deep: true
            }
        },
        created() {
            this.$eventHub.$on('invoiceSubmit', this.store);
            this.$eventHub.$on('setMailer', this.setMailer);
            this.$eventHub.$on('updateCkeditorHtml', this.updateHtml);
        },
        methods: {
            store(){
                window.BOLD.ajaxFormIsChanged = false;
                this.sent = true;
                this.model.invoice_id = this.invoice_id;
                this.$store('/api/mailer', this);
            },
            callback() {
                this.$eventHub.$emit('latest-notif', {
                    title: 'Email Sent',
                    timeout: true
                });
            },
            delRow(id){
                this.model.attachments.splice(id, 1);
                console.log('yes');
            },
            upload(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    console.log('no file');
                    return;
                }

                var data = new FormData();
                data.append('foo', 'bar');
                data.append('file', files[0]);
                var config = {
                    onUploadProgress: function (progressEvent) {
                        this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    }.bind(this)
                };
                this.axios.post('/api/upload/server', data, config).then(function (res) {
                    let data = res.data;
                    if (typeof data.attachments !== 'undefined') {
                        if (this.model.attachments.length) {
                            this.model.attachments.push(data.attachments);
                        } else {
                            this.model.attachments = [data.attachments];
                        }
                    }
                }.bind(this)).catch(function (err) {
                    console.log('error');
                    console.log(err.message);
                    alert(err.message);
                });
            },
            updateHtml(html) {
                this.sent = false;
                this.model.html = html;
            },
            setMailer(data) {
                this.sent = false;
                $.each(this.model, (key, value) => {
                    let val = '';
                    if (typeof data.fetchTemplate !== 'undefined') {
                        val = value;
                    }
                    if (typeof data[key] !== 'undefined') {
                        val = data[key];
                    }
                    this.model[key] = val;
                });
                this.$eventHub.$emit('updateCkeditor', this.model.html);
                if (window.isProposalPage === true) {
                    this.model.proposal = true;
                }
                this.$emit('input', this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('invoiceSubmit', this.store);
            this.$eventHub.$off('setMailer', this.setMailer);
        }
    }
</script>
<style scoped>
    .form-group.send-proposal {
        text-align: right;
        margin-top: 15px;
    }
    .form-group.send-proposal label {
        font-weight: bold;
        padding-top: 4px;
        float: right;
        padding-left: 7px;
    }
</style>